import React, { FC, ReactNode } from "react";
import clsx from "clsx";

import styles from "./index.module.css";

type DividerProps = {
  children?: ReactNode;
  className?: string;
};

const Divider: FC<DividerProps> = (props) => {
  const { children, className } = props;
  return <div className={clsx(styles.container, className)}>{children}</div>;
};

export default Divider;
